import React from 'react';
// import {get} from 'lodash';
import nprops from 'nested-props';
import Widget from './widget';
import esriStrings from '../../resources/esriStrings';
import tapdeatils from '../../resources/tapestrySegmentStats';
import 'react-accessible-accordion/dist/fancy-example.css';
import layerUrls from '../../resources/vtlayers';
import Accordion from '../accordian/accordian';
import './tapestry.scss';
const defaultFeilds = [
  {key: 'THH03_P', val: 13.97},
  {key: 'THH63_P', val: 10.4},
  {key: 'THH14_P', val: 10.34}
];


const parseID = (seg) => {
  if (seg) {
    return seg.split('_')[1];
  }

  return null;
};
const TapestryWidget = (props) => {
  const [tapestryArr, setTapestryArr] = React.useState([]);
  const [activeKey, setActiveKey] = React.useState(null);
  const onUpdateLayer = props.onUpdateLayer;
  const setActiveLegend = props.setActiveLegend;
  React.useEffect(() => {
    if (props.isActive) {
      onUpdateLayer(layerUrls.tapestry);
      setActiveLegend(null);
    }
  }, [props.isActive, onUpdateLayer, setActiveLegend]);

  React.useEffect(() => {
    setActiveKey(null);
    const fields = nprops.get(props.currentFeature, 'attributes.tap') || defaultFeilds;
    if (fields) {
      const segArr = fields.map(
        (record) => ({details: tapdeatils[record.key], percentage: record.val}));
      const filteredArr = segArr.filter(
        (seg) => typeof seg.details !== 'undefined'
      );
      setTapestryArr(filteredArr);
    }
  }, [props.currentFeature]);

  return (
    <Widget
      isActive={props.isActive}
      title={esriStrings.widgetOne}
      onWidget={() => props.onWidget(1)}
      info={props.info}
    >
      <Accordion
        onWidget={() => props.onWidget(1)}
        data={tapestryArr}
        activeSection={activeKey}
        handleSection={setActiveKey}
      ></Accordion>
    </Widget>
  );
};

TapestryWidget.propTypes = {};

export default TapestryWidget;
